/* =========================================================
   HOME DECORE — Product Page JS
   ========================================================= */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    initProductForm(root);
  });

  function initProductForm(root) {
    var productJson = root.querySelector('[data-product-json]');
    if (!productJson) return;
    var product = JSON.parse(productJson.textContent);

    var optionSelectors = root.querySelectorAll('[data-option-index]');
    var idInput = root.querySelector('[data-variant-id-input]');
    var priceWrap = root.querySelector('[data-product-price]');
    var inventoryWrap = root.querySelector('[data-inventory-status]');
    var addBtn = root.querySelector('[data-add-to-cart-btn]');
    var dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
    var backInStockWrap = root.querySelector('[data-back-in-stock]');
    var gallery = document.querySelector('[data-product-gallery="' + root.dataset.productForm + '"]') ||
                  root.closest('.product-page')?.querySelector('[data-product-gallery]');

    var selected = {};
    optionSelectors.forEach(function (group) {
      var preset = group.querySelector('.is-selected');
      var idx = group.getAttribute('data-option-index');
      selected[idx] = preset ? preset.getAttribute('data-value') : (product.options_with_values[idx] && product.options_with_values[idx].values[0]);
    });

    function findVariant() {
      if (!product.variants.length) return null;
      // Single-variant products (no option selectors) — use the only variant.
      if (!optionSelectors.length || product.has_only_default_variant) {
        return product.variants[0];
      }
      return product.variants.find(function (v) {
        return product.options.every(function (_, i) {
          return v.options[i] === selected[i];
        });
      });
    }

    function formatMoney(cents) {
      if (window.HomeDecore && window.HomeDecore.formatMoney) {
        return window.HomeDecore.formatMoney(cents);
      }
      var fmt = (window.themeSettings && window.themeSettings.moneyFormat) || '{{amount}}';
      var num = (Math.abs(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return (cents < 0 ? '-' : '') + fmt.replace(/\{\{\s*\w+\s*\}\}/, num);
    }

    function updateAvailability() {
      // Disable swatches with no matching combination for current partial selection
      optionSelectors.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          var value = btn.getAttribute('data-value');
          var testSelection = Object.assign({}, selected);
          testSelection[idx] = value;
          var matches = product.variants.some(function (v) {
            return product.options.every(function (_, i) {
              return testSelection[i] === undefined || v.options[i] === testSelection[i];
            }) && v.available;
          });
          btn.classList.toggle('is-disabled', !matches);
        });
      });
    }

    function render() {
      var variant = findVariant();
      updateAvailability();

      if (!variant) {
        if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = (window.themeStrings && window.themeStrings.unavailable) || 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceWrap) {
        var html = '';
        if (variant.compare_at_price > variant.price) {
          html += '<s>' + formatMoney(variant.compare_at_price) + '</s> <span class="price--sale">' + formatMoney(variant.price) + '</span>';
          html += '<span class="product-info__price-badge">Save ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%</span>';
        } else {
          html += formatMoney(variant.price);
        }
        priceWrap.innerHTML = html;
      }

      if (inventoryWrap) {
        inventoryWrap.classList.remove('is-low', 'is-out');
        var textEl = inventoryWrap.querySelector('[data-inventory-text]');
        if (!variant.available) {
          inventoryWrap.classList.add('is-out');
          if (textEl) textEl.textContent = 'Out of stock';
        } else if (variant.inventory_management && variant.inventory_quantity !== undefined && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          inventoryWrap.classList.add('is-low');
          if (textEl) textEl.textContent = 'Only ' + variant.inventory_quantity + ' left in stock';
        } else {
          if (textEl) textEl.textContent = 'In stock, ready to ship';
        }
      }

      if (addBtn) {
        if (variant.available) {
          addBtn.removeAttribute('aria-disabled');
          addBtn.textContent = (window.themeStrings && window.themeStrings.addToCart) || 'Add to Cart';
        } else {
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.textContent = (window.themeStrings && window.themeStrings.soldOut) || 'Sold Out';
        }
      }

      if (backInStockWrap) {
        backInStockWrap.style.display = variant.available ? 'none' : '';
        var variantIdField = backInStockWrap.querySelector('[name="variant_id"]');
        if (variantIdField) variantIdField.value = variant.id;
      }

      var qtyInput = root.querySelector('[data-qty-input]');
      if (qtyInput) {
        var newMax = 9999;
        if (variant.inventory_management && variant.inventory_policy === 'deny') {
          newMax = (variant.inventory_quantity > 0) ? variant.inventory_quantity : 1;
        }
        qtyInput.max = newMax;
        if (parseInt(qtyInput.value, 10) > newMax) qtyInput.value = newMax;
      }

      if (dynamicCheckout) {
        dynamicCheckout.style.display = variant.available ? '' : 'none';
      }

      // Update gallery to variant featured image
      if (gallery && variant.featured_image) {
        var slideIndex = Array.from(gallery.querySelectorAll('[data-media-id]')).findIndex(function (el) {
          return parseInt(el.getAttribute('data-media-id'), 10) === variant.featured_image.id;
        });
        if (slideIndex > -1 && window.HomeDecoreGallery && window.HomeDecoreGallery[gallery.dataset.galleryId]) {
          window.HomeDecoreGallery[gallery.dataset.galleryId].goTo(slideIndex);
        }
      }

      // Update option value display text (e.g. "Color: Burgundy")
      optionSelectors.forEach(function (group) {
        var idx = group.getAttribute('data-option-index');
        var valueDisplay = group.parentElement.querySelector('[data-option-value-display]');
        if (valueDisplay) valueDisplay.textContent = selected[idx];
      });

      root.dispatchEvent(new CustomEvent('variant:change', { detail: variant, bubbles: true }));
    }

    optionSelectors.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn || btn.classList.contains('is-disabled')) return;
        var idx = group.getAttribute('data-option-index');
        group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selected[idx] = btn.getAttribute('data-value');
        render();
      });
    });

    render();
  }

  /* ---------------- Gallery slider + zoom ---------------- */
  window.HomeDecoreGallery = window.HomeDecoreGallery || {};

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery, i) {
    var id = gallery.dataset.galleryId || ('gallery-' + i);
    gallery.dataset.galleryId = id;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.from(gallery.querySelectorAll('.product-gallery__slide'));
    var thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    var counter = gallery.querySelector('[data-gallery-counter]');
    var current = 0;

    function goTo(index) {
      current = Math.max(0, Math.min(slides.length - 1, index));
      if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;

      var video = slides[current] && slides[current].querySelector('video');
      slides.forEach(function (s) {
        var v = s.querySelector('video');
        if (v && v !== video) v.pause();
      });
    }

    gallery.querySelectorAll('[data-gallery-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(current - 1 < 0 ? slides.length - 1 : current - 1); });
    });
    gallery.querySelectorAll('[data-gallery-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(current + 1 >= slides.length ? 0 : current + 1); });
    });
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { goTo(idx); }); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { goTo(idx); }); });

    // Swipe support
    var touchStartX = 0;
    gallery.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) > 50) goTo(current + (diff < 0 ? 1 : -1));
    }, { passive: true });

    // Zoom on click (toggle 1.8x, follow cursor)
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      slide.addEventListener('click', function (e) {
        if (window.innerWidth < 750) return;
        var isZoomed = slide.classList.toggle('is-zoomed');
        if (isZoomed) {
          img.style.transform = 'scale(1.8)';
          moveZoom(e);
        } else {
          img.style.transform = '';
        }
      });
      slide.addEventListener('mousemove', function (e) {
        if (slide.classList.contains('is-zoomed')) moveZoom(e);
      });
      function moveZoom(e) {
        var rect = slide.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      }
    });

    window.HomeDecoreGallery[id] = { goTo: goTo };
  });

  /* ---------------- Sticky add to cart ---------------- */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var mainForm = document.querySelector('form.js-product-form, [data-add-to-cart-form]');
  if (stickyAtc && mainForm) {
    var trigger = document.querySelector('[data-sticky-atc-trigger]') || mainForm;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(trigger);

    stickyAtc.addEventListener('click', function (e) {
      if (e.target.closest('[data-sticky-atc-submit]')) {
        e.preventDefault();
        if (mainForm) {
          mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      }
    });
  }

  /* ---------------- Back in stock form (placeholder submit handling) ---------------- */
  document.querySelectorAll('form.js-back-in-stock-form, [data-back-in-stock-form]').forEach(function (form) {
    var toggleBtn = form.parentElement.querySelector('[data-back-in-stock-toggle]');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        form.classList.toggle('is-active');
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = form.querySelector('[data-back-in-stock-success]');
      form.querySelector('input[type="email"]').value = '';
      if (msg) msg.style.display = 'block';
    });
  });
})();
